import Link from 'next/link';
import { useEffect, useState } from 'react';

import { BANNER_SETTINGS, BANNER_STORAGE_KEY, SHOW_BANNER_DEFAULT } from '@/constants/banner';

import { fontStyles } from '@/styles/typography';

import { AnnouncementBanner } from '@/ui/AnnouncementBanner';
import { ChainAvatar } from '@/ui/Avatars/ChainAvatar';

import { getDefaultPairForChain } from '@/utils/swap';
import { tradeRoute } from '@/utils/url';

export const ApplicationBanner = () => {
  const [showBanner, setShowBanner] = useState(SHOW_BANNER_DEFAULT);
  const { error, newChain } = BANNER_SETTINGS;

  // Keep the initial markup stable, then read _document's pre-hydration visibility decision.
  useEffect(() => {
    setShowBanner(document.body.dataset.showBanner === 'true');
  }, []);

  const hideBanner = () => {
    window.localStorage.setItem(BANNER_STORAGE_KEY, 'true');
    document.body.dataset.showBanner = 'false';
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  if (error) {
    return (
      <AnnouncementBanner title={error.title} variant="error" onDismiss={hideBanner}>
        {error.description}
      </AnnouncementBanner>
    );
  }

  if (newChain) {
    return (
      <AnnouncementBanner variant="new" onDismiss={hideBanner}>
        <div className="flex flex-row items-center gap-1.5">
          <ChainAvatar chainId={newChain.id} size={20} />
          <p className={fontStyles({ variant: 'LABEL_MD' })}>{newChain.name}</p>
          <p>is live on Matcha.</p>
          <Link
            href={tradeRoute({
              address: getDefaultPairForChain(newChain.id).buyAddress,
              chainId: newChain.id,
            })}
            className={fontStyles({
              variant: 'LABEL_MD',
              class:
                'whitespace-nowrap text-token-green-1100 underline hover:text-token-green-1200',
            })}
          >
            Try it now
          </Link>
        </div>
      </AnnouncementBanner>
    );
  }

  return null;
};
